import { Metrics } from '../../utils/metrics';
import { TRACKING_SOURCES, trackCommunicationMethodsInteraction } from '../../utils/tracking';

// HubSpot Conversations Widget injects these properties onto window at runtime.
// §18 adapter: third-party injection forces the cast; isolated here so consumer
// code stays cast-free.
const chatWin = window;
function getSettings() {
  var _chatWin$hsConversati;
  const existing = (_chatWin$hsConversati = chatWin.hsConversationsSettings) !== null && _chatWin$hsConversati !== void 0 ? _chatWin$hsConversati : {
    loadImmediately: false
  };
  chatWin.hsConversationsSettings = existing;
  return existing;
}
function getWidget() {
  var _chatWin$HubSpotConve;
  return (_chatWin$HubSpotConve = chatWin.HubSpotConversations) === null || _chatWin$HubSpotConve === void 0 ? void 0 : _chatWin$HubSpotConve.widget;
}
function getApi() {
  return chatWin.HubSpotConversations;
}
function onReady(callback) {
  const api = getApi();
  if (api) {
    callback();
  } else {
    var _chatWin$hsConversati2;
    chatWin.hsConversationsOnReady = [...((_chatWin$hsConversati2 = chatWin.hsConversationsOnReady) !== null && _chatWin$hsConversati2 !== void 0 ? _chatWin$hsConversati2 : []), callback];
  }
}

// Guard so a repeat call (e.g. a double boot) doesn't double-register the
// conversationStarted listener or re-fire the loaded event/metric.
let hasSetupTracking = false;
export const Chat = {
  getStatus() {
    var _getWidget;
    const status = (_getWidget = getWidget()) === null || _getWidget === void 0 ? void 0 : _getWidget.status();
    return {
      loaded: !!(status !== null && status !== void 0 && status.loaded),
      pending: !!(status !== null && status !== void 0 && status.pending)
    };
  },
  setInlineEmbed(selector) {
    getSettings().inlineEmbedSelector = selector;
    return Chat;
  },
  removeInlineEmbed() {
    delete getSettings().inlineEmbedSelector;
    return Chat;
  },
  load() {
    onReady(() => {
      var _getWidget2;
      (_getWidget2 = getWidget()) === null || _getWidget2 === void 0 || _getWidget2.load();
    });
    return Chat;
  },
  remove() {
    onReady(() => {
      var _getWidget3;
      (_getWidget3 = getWidget()) === null || _getWidget3 === void 0 || _getWidget3.remove();
    });
    return Chat;
  },
  on(event, callback) {
    onReady(() => {
      var _getApi;
      (_getApi = getApi()) === null || _getApi === void 0 || _getApi.on(event, callback);
    });
    return Chat;
  },
  off(event, callback) {
    onReady(() => {
      var _getApi2;
      (_getApi2 = getApi()) === null || _getApi2 === void 0 || _getApi2.off(event, callback);
    });
    return Chat;
  },
  setupTracking() {
    onReady(() => {
      var _getApi3;
      if (hasSetupTracking) {
        return;
      }
      hasSetupTracking = true;
      trackCommunicationMethodsInteraction({
        action: 'chat-conversation-loaded',
        trackingSource: TRACKING_SOURCES.PUBLIC
      });
      Metrics === null || Metrics === void 0 || Metrics.counter('live-chat-loaded', {
        location: TRACKING_SOURCES.PUBLIC
      }).increment();
      (_getApi3 = getApi()) === null || _getApi3 === void 0 || _getApi3.on('conversationStarted', payload => {
        // The widget owns this payload's shape; assert it at the third-party
        // boundary rather than narrowing `unknown`. Optional chaining keeps a
        // malformed payload from throwing.
        const {
          conversation
        } = payload;
        trackCommunicationMethodsInteraction({
          action: 'chat-conversation-started',
          trackingSource: TRACKING_SOURCES.PUBLIC,
          conversationId: conversation === null || conversation === void 0 ? void 0 : conversation.conversationId
        });
        Metrics === null || Metrics === void 0 || Metrics.counter('live-chat-interaction', {
          location: TRACKING_SOURCES.PUBLIC
        }).increment();
      });
    });
    return Chat;
  }
};